import React from "react";
import { normalizeProps } from "./utils/normalizeProps";

const InternacaoIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...normalizeProps(props)}
    >
      <path
        d="M8.5 2.99902C7.67157 2.99902 7 3.6706 7 4.49902V7H4.5C3.67157 7 3 7.67157 3 8.5V11.5C3 12.3284 3.67157 13 4.5 13H7V15.5009C7 16.3294 7.67157 17.0009 8.5 17.0009H11.5C12.3284 17.0009 13 16.3294 13 15.5009V13H15.5C16.3284 13 17 12.3284 17 11.5V8.5C17 7.67157 16.3284 7 15.5 7H13V4.49902C13 3.6706 12.3284 2.99902 11.5 2.99902H8.5Z"
        fill="white"
      />
    </svg>
  );
};

export default InternacaoIcon;
